import React from 'react';
import useGame from '../hooks/useGame';

const LanguageSwitcher = () => {

  const { language, setLanguage } = useGame();
  const { REACT_APP_LANGUAGE } = process.env;

  // if we are on Lithuanian site, no language switcher needed
  if (language.toLowerCase() === 'lt') {
    return '';
  }

  const changeLanguage = async () => {
    const newLanguage = language.toLowerCase() === 'ru' ? REACT_APP_LANGUAGE.toLowerCase() : 'ru';
    window.document.documentElement.lang = newLanguage;
    setLanguage(newLanguage);
  };

  const getLanguage = (lang) => {
    if(lang.toLowerCase() === 'et'){
      return 'EST';
    }

    return lang.toUpperCase();
  }

  return (
    <button tabIndex={0} onClick={changeLanguage} className="default lang-button">{language.toLowerCase() === 'ru' ? 'RU' : getLanguage(REACT_APP_LANGUAGE)}</button>
  )

  // return (
  //   <a href="#" className="lang" onClick={changeLanguage}>{language.toLowerCase() === 'ru' ? REACT_APP_LANGUAGE.toUpperCase() : 'RU'}</a>
  // );
};

export default LanguageSwitcher;
